import { Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, TextField, Tooltip } from '@mui/material'
import { Autocomplete, createFilterOptions } from '@mui/material';
import { useState, useEffect } from 'react';
import { PhoneNumberModel } from '../../../models/phone-number.model';
import { UtilityService } from '../../../services/UtilityService';
import ButtonComponent from '../button/button.component';
import { buttonLabels } from '../constants';
import { findIndex } from 'lodash';
import { CancelIcon } from '../../../icon';
import * as selector from '../../../selectors/selectors'
import { useSelector } from 'react-redux';

interface Props {
    Title: string;
    OnClose: () => void;
    Show: boolean;
    HandleSubmit: (ids: string[]) => void;
    Loading: boolean;
    Options: PhoneNumberModel[];
    ButtonName: string;
    Error?: string
}

const SelectPhoneNumberComponent = (props: Props) => {
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const Autofilter = createFilterOptions();
    const [phoneNumbers, setPhoneNumbers] = useState<string[]>()
    const [error, setErrors] = useState<{
        PhoneNumber: string
    }>({
        PhoneNumber: ""
    })
    useEffect(() => {
        setPhoneNumbers([])
    }, [])

    const handleCheckBox = (event: any, values: PhoneNumberModel[]) => {
        let val = values.map(x => findIndex(x.ID))
        if (val.find(x => x === -1)) {
            if (props.Options.length === phoneNumbers.length) {
                setPhoneNumbers([])
            }
            else {
                setPhoneNumbers(props.Options.map(x => x.ID))
            }
        }
        else {
            setPhoneNumbers(values.map(x => x.ID))
        }
    };

    const handleClose = () => {
        setPhoneNumbers([])
        props.OnClose()
    }

    const optionRenderer = (defaultprops, option: any, { selected }: any) => {
        const selectAllProps =
            phoneNumbers.length > 0 && option.value === -1
                ? { checked: (props.Options.length === phoneNumbers.length) }
                : {};
        return (
            <li {...defaultprops} className={"h6 d-flex w-p-100"}>
                <Checkbox
                    name="checkbox"
                    className="mr-1"
                    classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                    indeterminate={option.value === -1 && props.Options.length - 1 === phoneNumbers.length}
                    checked={selected}
                    {...selectAllProps}
                />
                <div className={`my-auto t-align-left`}> {IsMobileDevice ? UtilityService.trimMessage(option?.Name, 20) : option?.Name} </div>
                <div className={`my-auto ml-auto mr-3`}> {UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber)}</div>
            </li>
        )
    }
    return (
        <Dialog
            maxWidth="sm"
            fullWidth={true}
            disableEscapeKeyDown
            BackdropProps={IsMobileDevice ? {} : { style: { backgroundColor: "transparent" } }}
            open={props.Show}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paper: "br-2 dialogue-shadow bg-color-sidebar-bg" }}
        >
            <DialogTitle id="alert-dialog-title" className="dialog-header">
                <div className='d-flex'>
                    <span className={"h2-regular color-display-title"}>{props.Title}</span>
                    <Tooltip title='Close' placement='bottom-start' className='min-w-2'>
                        <CancelIcon className={"c-pointer ml-auto"} onClick={handleClose} />
                    </Tooltip>
                </div>
            </DialogTitle>
            <form action="" noValidate autoComplete="off" onSubmit={(e) => { e.preventDefault(); props.HandleSubmit(phoneNumbers) }} >
                <DialogContent className="o-hidden">
                    <FormHelperText className="body1 color-primary-danger t-align-right mb-1">
                        {props.Error}
                    </FormHelperText>
                    <Autocomplete
                        multiple
                        size="small"
                        disableCloseOnSelect={true}
                        options={props.Options}
                        getOptionLabel={(option) => option?.Name}
                        classes={{ input: 'h2 color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                        onChange={handleCheckBox}
                        value={PhoneNumbers.filter(x => phoneNumbers?.includes(x.ID))}
                        filterOptions={(options: any[], params: any) => {
                            if (props.Options.length > 0) {
                                const filtered = Autofilter(options, params);
                                return [{ Name: "Select all", value: -1 }, ...filtered];
                            } else if (props.Options.length === 0) {
                                const filtered = Autofilter(options, params);
                                return [...filtered];
                            }
                            else { return options; }
                        }}
                        renderOption={optionRenderer}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip
                                    classes={{
                                        colorPrimary: "custom-color-chip-2",
                                        avatarColorPrimary: "custom-chip-avatar",
                                    }}
                                    color='primary'
                                    label={option.Name}
                                    {...getTagProps({ index })}
                                />
                            ))
                        }
                        renderInput={(params) => <TextField {...params} label="Select Phone Number" name="PhoneNumbers" required variant="outlined" />}
                    />
                    <FormHelperText className="body1 color-primary-danger t-align-right">
                        {error.PhoneNumber}
                    </FormHelperText>
                </DialogContent>
                <DialogActions>
                    <ButtonComponent Variant="secondary-btn-small" ClassName={"mr-1"} OnClick={handleClose} ButtonLabel={buttonLabels.CANCEL} />
                    <ButtonComponent Variant={phoneNumbers?.length > 0 && !props.Error ? "primary-btn-small" : "disabled-btn-small"} ClassName={"px-4 mr-2"} Type={"submit"} ButtonLabel={props.ButtonName} Loading={props.Loading} />
                </DialogActions>
            </form>
        </Dialog>
    )
}

export default SelectPhoneNumberComponent;